import React from "react";

export default function HamburgerMenu(props) {
  return (
    <svg
      width="22px"
      height="18px"
      viewBox="0 0 20 16"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...props}
    >
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="header-bar"
          transform="translate(-14.000000, -14.000000)"
          fill="#FFFFFF"
        >
          <g id="hamburger" transform="translate(14.000000, 14.000000)">
            <g>
              <path d="M19,2 L1,2 C0.448,2 0,1.552 0,1 L0,1 C0,0.448 0.448,0 1,0 L19,0 C19.552,0 20,0.448 20,1 L20,1 C20,1.552 19.552,2 19,2" />
              <path d="M19,9 L1,9 C0.448,9 0,8.552 0,8 L0,8 C0,7.448 0.448,7 1,7 L19,7 C19.552,7 20,7.448 20,8 L20,8 C20,8.552 19.552,9 19,9" />
              <path d="M19,16 L1,16 C0.448,16 0,15.552 0,15 L0,15 C0,14.448 0.448,14 1,14 L19,14 C19.552,14 20,14.448 20,15 L20,15 C20,15.552 19.552,16 19,16" />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
